import React from "react";
import styles from "./signedOutSetupWatchlist.module.css";
import WatchlistWell from "~components/WatchlistWell";
import SignedOutWatchlistContainer from "~components/SignedOutWatchlistContainer";
import WatchlistBundleContainer from "~components/WatchlistBundleContainer";

type SignedOutSetupWatchlistProps = {
  signInModal: () => void;
  registerModal: () => void;
};

export default function SignedOutSetupWatchlist(
  props: SignedOutSetupWatchlistProps
) {
  const { signInModal, registerModal } = props;

  return (
    <WatchlistWell>
      <div className={styles.watchlistSetupContainer}>
        <SignedOutWatchlistContainer
          signInModal={signInModal}
          registerModal={registerModal}
        />
        <div className={styles.logicalOperatorText}>OR</div>
        <WatchlistBundleContainer handleButtonClick={signInModal} />
      </div>
    </WatchlistWell>
  );
}
